import { apis } from "../../backend";
import { Project } from "../../models/Project";

export async function listProjects(): Promise<Project[]> {
  const projects = await apis.users.get<Project[]>('/projects-v1');

  return projects.map(project => new Project(project));
}